import React from 'react';
import { ButtonGroup, FormControl, FormLabel } from 'chakra';
import { Button } from 'components/Button/button.component';

interface Option<T> {
  label: string;
  value: T;
}

export interface RadioButtonGroupProps<T> {
  label: string;
  options: Option<T>[];
  selected: T;
  isDisabled?: boolean;
  onChange: (value: T) => void;
}

export const RadioButtonGroup = <T,>({
  label,
  options,
  selected,
  isDisabled,
  onChange,
}: RadioButtonGroupProps<T>): JSX.Element => {
  return (
    <FormControl w="100%">
      <FormLabel fontWeight="bold">{label}</FormLabel>
      <ButtonGroup spacing={0} w="100%">
        {options.map((option, index) => (
          <Button
            isDisabled={isDisabled}
            width="100%"
            key={option.label}
            onClick={(): void => onChange(option.value)}
            variant="secondarySubtle"
            borderRightRadius={index === options.length - 1 ? 4 : 0}
            borderLeftRadius={index === 0 ? 4 : 0}
            isActive={option.value === selected}
          >
            {option.label}
          </Button>
        ))}
      </ButtonGroup>
    </FormControl>
  );
};
